@reference "@glow/tailwind-config/reference.css";

.button {
  @apply inline-block;
  @apply relative;
  @apply px-4;
  @apply py-3;
  @apply leading-none;
  @apply whitespace-nowrap;
  @apply rounded-sm;
  @apply border;
  @apply border-transparent;
  @apply cursor-pointer;
  @apply border-solid;
  @apply text-sm;
  @apply leading-3;
  @apply h-10;
}

.label {
  @apply contents;
}

.button.small {
  @apply px-3;
  @apply py-2;
  @apply text-xs;
  @apply h-8;
}

.button svg {
  @apply mr-2;
  @apply pointer-events-none;
}

.button[disabled] {
  @apply opacity-30;
  @apply cursor-not-allowed;
}

.primary,
button.primary {
  @apply font-semibold;
  @apply bg-primary-500;
  @apply text-primary-overlay-500;
}

.primary:hover,
button.primary:hover {
  @apply bg-primary-900;
}

.primary:hover,
button.primary:hover,
.secondary:hover,
.tertiary:hover {
  box-shadow: 3px 3px 0px 0px rgba(0, 0, 0, 0.45);
}

.secondary {
  @apply font-semibold;
  @apply text-primary-600;
  @apply border-primary-600;
  @apply bg-transparent;
}

.secondary:hover {
  @apply bg-gray-200;
}
.tertiary:hover {
  @apply bg-gray-100;
}

button.danger {
  @apply font-semibold;
  @apply bg-red-700;
  @apply text-white;
}

.danger:hover {
  @apply bg-red-900;
}

.tertiary {
  @apply text-primary-600;
  @apply bg-transparent;
  @apply underline;
  @apply font-semibold;
}
